import React from "react";
import classNames from "classnames";
import styles from "./Spinner.scss";

export const Spinner = ({ size, color }) => {
    return (
        <div
            className={classNames(styles.base, {
                [styles.sizeSmall]: size === "small",
                [styles.sizeLarge]: size === "large",
                [styles.sizeFill]: size === "fill",
                [styles.colorPrimary]: color === "primary",
                [styles.colorContrast]: color === "contrast",
                [styles.colorError]: color === "error"
            })}
        >
            <svg className={styles.circular} viewBox="25 25 50 50">
                <circle className={styles.trail} cx="50" cy="50" r="20" fill="none" />
                <circle className={styles.path} cx="50" cy="50" r="20" fill="none" />
            </svg>
        </div>
    );
};
